<div *ngIf="prodVendors as pVen else pvloading">
  <p-table #PVT [value]="pVen"
           [rowHover]="true"
           selectionMode="single"
           [(selection)]="selectedProdVendor"
           dataKey="VENDORSITEMID"
           editMode="row"
           (onRowSelect)="onPvRowSelect($event)"
           (onRowUnselect)="onPvRowUnselect($event)"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem !important">...</th>
        <th style="width: 6rem !important">&nbsp;</th>
        <th style="width: auto !important; text-align: center">Поставщик ({{rowDetails}}) </th>
        <th style="width: auto !important; text-align: center">Валюта </th>
        <th style="width: 9rem !important; text-align: center">Цена (FOB) </th>
        <th style="width: 3rem !important; text-align: center">
          <button pButton pRipple type="button" icon="pi pi-chart-line" class="p-button-rounded p-button-text" pTooltip="Изменение цены за 3 месяца" tooltipPosition="top"></button>
        </th>
        <th style="width: 7rem !important; text-align: center" *ngIf="!editMode">(+Доставка) </th>
        <th style="width: 12rem !important; text-align: center" *ngIf="editMode">(+Доставка) </th>
        <th style="width: auto !important; text-align: center" *ngIf="!editMode">(+Переменная) </th>
        <th style="width: 7rem !important; text-align: center" *ngIf="!editMode">(*Пошлина) </th>
        <th style="width: auto !important; text-align: center" *ngIf="editMode">(*Пошлина) </th>
        <th style="width: auto !important; text-align: center" *ngIf="!editMode">(*Переменная) </th>
        <th style="width: 7rem !important; text-align: center" *ngIf="!editMode">Входная </th>
        <th style="width: 7rem !important; text-align: center">Маржа </th>
        <th style="width: 9rem !important; text-align: center" *ngIf="!editMode">Розничная </th>
        <th style="width: 9rem !important; text-align: center" *ngIf="editMode">Желаемая розница {{roundVatPriceCurr | number:'1.2-2' }} </th>
        <!--<th style="width: 7rem !important; text-align: center" *ngIf="!editMode">Округление </th>-->
        <th style="width: 7rem !important; text-align: center" *ngIf="!editMode">{{mainCurrencyColumnName}} </th>
        <th style="width: auto !important; text-align: center" *ngIf="!editMode">Примечание </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-pv let-editing="editing" let-ri="rowIndex" let-expanded="expanded">
      <tr [pSelectableRow]="pv" [pEditableRow]="pv" [class.bold-row]="(product.PRODPRICEVID==pv.VENDORSITEMID)">

        <td style="width: 3rem !important">
          <button type="button" pButton pRipple
                  [pRowToggler]="pv" class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
          </button>
        </td>

        <td>
          <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onPvRowEditInit(pv)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-save" (click)="onPvRowEditSave(pv)" class="p-button-warning p-button-rounded p-button-text mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onPvRowEditCancel(pv, ri)" class="p-button-danger p-button-rounded p-button-text"></button>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div style="padding-top: 1rem !important">
                <app-companyselector [showLabel]="false" [parentCompany]="0" [selectedID]="pv.VENDORID" (selectedCompanyID)="onVendorIdSelect($event, pv)" [style]="{'width':'100%'}"></app-companyselector>
              </div>
            </ng-template>
            <ng-template pTemplate="output" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
              <a [routerLink]="['/edit-client', pv.VENDORID]">{{pv.VENDORNIKNAME}}</a>
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div style="padding-top: 1rem !important">
                <app-currencyselector [showLabel]="false" [selectedID]="pv.VPCURRID" (SelectedCurrency)="onCurrencySelect($event, pv)" [style]="{'width':'100%'}"></app-currencyselector>
              </div>
            </ng-template>
            <ng-template pTemplate="output">{{pv.CURCODE }}</ng-template>
          </p-cellEditor>
        </td>

        <td style="min-width: 9rem !important">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="pv.VENDORPRICE" (ngModelChange)="onMarginChange($event, pv)"
                     [style]="{'width':'100%'}" step="0.01" style="text-align: right" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output"><div class="col" style="text-align: right">{{pv.VENDORPRICE | number:'1.2-2' }}</div></ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align:center">
          <button *ngIf="!editing && !editMode && (pv.vpc > 0.5)" pButton pRipple type="button" icon="pi pi-arrow-up" class="p-button-rounded p-button-text p-button-danger"
                  [pTooltip]="pv.vpcstr" tooltipPosition="top"></button>
          <button *ngIf="!editing && !editMode && (pv.vpc < -0.5)" pButton pRipple type="button" icon="pi pi-arrow-down" class="p-button-rounded p-button-text p-button-success"
                  [pTooltip]="pv.vpcstr" tooltipPosition="top"></button>
        </td>

        <td style="text-align: right">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="pv.VPADDCONST" (ngModelChange)="onMarginChange($event, pv)"
                     [style]="{'width':'100%'}" step="0.1" style="text-align: right" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output" style="text-align: right">{{pv.VPADDCONST | number:'1.2-2' }}</ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="!editMode">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div style="padding-top: 1rem !important">
                <app-variable-selector [selectedID]="pv.VPADDVAR" [showLabel]="false" (selectedVariable)="onVaVarSelection($event,pv)" [style]="{'width':'100%'}"></app-variable-selector>
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              ({{pv.VAVARCODE}}) {{pv.VAVARVALUE | number:'1.2-2' }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td >
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="pv.VPMULCONST" (ngModelChange)="onMarginChange($event, pv)"
                     [style]="{'width':'100%'}" step="0.1" style="text-align: right" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output"><div class="col" style="text-align: right">{{pv.VPMULCONST | number:'1.2-2' }}</div></ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="!editMode">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div style="padding-top: 1rem !important">
                <app-variable-selector [selectedID]="pv.VPMULVAR" [showLabel]="false" (selectedVariable)="onVmVarSelection($event,pv)" [style]="{'width':'100%'}"></app-variable-selector>
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              ({{pv.VMVARCODE}}) {{pv.VMVARVALUE | number:'1.2-2' }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right" *ngIf="!editMode">
          {{pv.VPINCOMEPRICE | number:'1.2-2' }}
        </td>

        <td style="min-width: 9rem !important">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="pv.VENDORMARGIN" (ngModelChange)="onMarginChange($event, pv)"
                     [style]="{'width':'100%'}" step="0.01" style="text-align: right" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output"><div class="col" style="text-align: right">{{pv.VENDORMARGIN | number:'1.2-2' }}</div></ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="pv.VPOUTCOMEPRICE" (ngModelChange)="onOutcomePriceChange($event, pv)"
                     [style]="{'width':'100%'}" step="0.01" style="text-align: right" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">{{pv.VPOUTCOMEPRICE | number:'1.2-2' }}</ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right" *ngIf="!editMode">
          <p-cellEditor>
            <ng-template pTemplate="output">
              <!--{{pv.VENROUNDBASE | number:'1.2-2' }}-->
              {{pv.outComePriceInMainCurrency | number:'1.2-2' }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td *ngIf="!editMode">
          <input pInputText type="text" [(ngModel)]="pv.VENDORNOTE" [style]="{'width':'100%'}" readonly (keydown)="$event.stopPropagation()">
        </td>
      </tr>

      <tr *ngIf="editing">
        <td colspan="2" style="padding: 1rem !important">&nbsp;</td>
        <td colspan="3" style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 600">Примечание к расчету цены</td>
        <th style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">Округление </th>
        <th style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">(+Переменная) {{pv.VAVARVALUE}}</th>
        <th style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">(*Переменная) {{pv.VMVARVALUE}}</th>
        <th style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">Входная </th>
        <th style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"> {{mainCurrencyColumnName}} </th>
      </tr>

      <tr [pEditableRow]="pv" *ngIf="editing">
        <td colspan="2">&nbsp;</td>

        <td colspan="3">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="pv.VENDORNOTE" [style]="{'width':'100%','background-color':'lightgray'}" (keydown)="$event.stopPropagation()">
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="pv.VENROUNDBASE" [style]="{'width':'100%'}" step="0.01" style="text-align: right" (keydown)="$event.stopPropagation()">
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div class="fluid">
                <div class="col">
                  <app-variable-selector [selectedID]="pv.VPADDVAR" [showLabel]="false" (selectedVariable)="onVaVarSelection($event,pv)" [style]="{'width':'100%'}"></app-variable-selector>
                </div>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div class="fluid">
                <div class="col">
                  <app-variable-selector [selectedID]="pv.VPMULVAR" [showLabel]="false" (selectedVariable)="onVmVarSelection($event,pv)" [style]="{'width':'100%'}"></app-variable-selector>
                </div>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align: right">{{pv.VPINCOMEPRICE | number:'1.2-2' }}</td>
        <td style="text-align: right"><p-button label="{{roundVatPriceMain | number:'1.2-2' }}" (onClick)="insertPriceInMain()" pTooltip="{{pv.outComePriceInMainCurrency | number:'1.2-2' }}" /> </td>

      </tr>

      <tr *ngIf="editing" style="background-color: darkseagreen">
        <td colspan="2" style="padding: 1rem !important">&nbsp;</td>
        <td colspan="3" style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 600">Старая формула расчета входной цены</td>
        <td colspan="5" style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 600">Старая формула расчета выходной цены</td>
      </tr>

      <tr *ngIf="editing" [pEditableRow]="pv" style="background-color: darkseagreen">
        <td colspan="2">&nbsp;</td>
        <td colspan="3">
          <p-cellEditor>
            <ng-template pTemplate="input">
            <input pInputText type="text" [(ngModel)]="pv.VPINCOMPRICEXPR" [style]="{'width':'100%','background-color':'lightgray'}" (keydown)="$event.stopPropagation()">
            </ng-template>
          </p-cellEditor>
        </td>

        <td colspan="5">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="pv.EUPRICEEXPR" [style]="{'width':'100%','background-color':'lightgray'}" (keydown)="$event.stopPropagation()">
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>

    </ng-template>
    <ng-template pTemplate="rowexpansion" let-pv>
      <tr>
        <td colspan="10" *ngIf="editMode">
          <div class="p-p-1">
            <app-product-price-history [prodId]="pv.PRODID" [vendorId]="pv.VENDORID"></app-product-price-history>
          </div>
        </td>
        <td colspan="15" *ngIf="!editMode">
          <div class="p-p-1">
            <app-product-price-history [prodId]="pv.PRODID" [vendorId]="pv.VENDORID"></app-product-price-history>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="grid formgrid">
    
  </div>
</div>

<ng-template #pvloading>
  <p>Информация о поставщиках загружается...</p>
</ng-template>

<div class="grid formgrid justify-content-end">
  <p-button label="Сделать основным" icon="pi pi-dollar" (onClick)="onChangeVendorInfo($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="canNotSetAsMainRow"
            pTooltip="Использовать выбранную строку для расчета розничной цены" tooltipPosition="top"></p-button>
  <p-button label="Удалить поставщика" icon="pi pi-minus" (onClick)="onRemoveVendorInfo($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="canNotSetAsMainRow"
            pTooltip="Убрать выбранного поставщика" tooltipPosition="top"></p-button>
  <p-button label="Добавить поставщика" icon="pi pi-plus" (onClick)="onAddVendorInfo($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="editMode"
            pTooltip="Добавить нового поставщика" tooltipPosition="top"></p-button>
</div>
